import React from 'react';

import ContentCard from 'pages/Landings/components/ContentCard';

import useStyles from './styles';

interface Props {
    className?: string;
}

const Promo: React.FC<Props> = ({ className }) => {
    const { classes, cx } = useStyles();
    return (
        <ContentCard className={cx(classes.root, className)}>
            <p className={classes.title}>
                {'Vulners empowers organizations to build custom solutions '}
                <span className={classes.accent}>{'faster, smarter, and at scale'}</span>
                {' using our powerful data platform and SDK'}
            </p>
        </ContentCard>
    );
};

export default Promo;
